import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled, Box as MuiBox, Divider } from '@mui/material';
import { BodyMediumRegular } from 'v3/shared/typography/BodyMedium';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    padding: '1.5rem',

    [theme.breakpoints.up('sm')]: {
      borderRadius: '0.375rem',
    },
  },
}));

export const Content = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  gap: '1.5rem',
  alignItems: 'center',
}));

export const ButtonDivider = styled('div')({
  marginTop: '1rem',
});

export const TextDivider = styled('div')({
  marginBottom: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
});

export const ResendPix = styled('a')(({ theme }) => ({
  color: theme.palette.warning.main,
  textAlign: 'left',
  display: 'block',
  textDecoration: 'underline',
  cursor: 'pointer',
}));

export const CloseBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const TimerContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: 0,
  gap: '0.5rem',
  marginTop: '1.5rem',
  width: '100%',
});

export const TextContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  marginTop: '1.5rem',
  color: theme.palette.secondary.light,
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  width: '100%',
  color: theme.palette.secondary.light,
  fontSize: '0.75rem',
  opacity: 0.6,
  '&::before, &::after': {
    borderColor: theme.palette.secondary.light,
    borderTopStyle: 'solid',
    borderTopWidth: '0.063rem',
    opacity: 0.6,
  },
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
}));

export const Icon = styled('img')(() => ({
  width: '9.5rem',
}));

export const BodyMediumRegularStyled = styled(BodyMediumRegular)(({ theme }) => ({
  color: theme.palette.common.white,
  marginTop: '2rem',
  align: 'center',
}));

export const BodySmallRegularStyled = styled(BodySmallRegular)(({ theme }) => ({
  color: theme.palette.common.white,
  marginTop: '1rem',
  marginBottom: '2rem',
  textAlign: 'center',
}));